import { render, staticRenderFns } from "./TextTransform2.vue?vue&type=template&id=3a03ad36&"
var script = {}
import style0 from "./TextTransform2.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports